<script setup>
//region Imports
import { ref, onMounted, reactive } from 'vue'
//endregion
//region Methods
const readData = () => JSON.parse(localStorage.getItem('tc-claim-data'))

const readSelectedItems = () => JSON.parse(localStorage.getItem('tc-claim-selected-items'))

const clickToBack = () => location.replace('#/claim/compensation')

const clickToContinue = () => location.replace('#/claim/review')

const editAddress = () => location.replace('#/claim/shipping/edit')
//endregion
//region Variables
const data = reactive(readData() ?? {})
const items = reactive(readSelectedItems() ?? [])
let orderNumber = ref(data?.orderNumber)
//endregion
//region Lifecycle
onMounted(() => {
  if (!orderNumber.value) {
    location.replace('/')
  }
})
//endregion
</script>

<template>

  <header class="bg-tc-off-white-two overflow-hidden flex items-center justify-center h-[280px]">
    <div class="relative min-w-[171px] h-[171px]">
      <img :src="items[0]?.image" class="w-[143px] shadow z-50 absolute top-0 right-0" alt="image"/>
      <div v-if="items.length > 1">
        <span class="absolute bg-black rounded-full text-white text-tc-subtitle font-medium font-avenir w-[27px] h-[27px] flex justify-center items-center z-50 -top-1.5 -right-1.5"
              v-text="items.length"></span>
        <img :src="items[1]?.image ?? items[0]?.image" class="w-[143px] shadow z-20 absolute top-2 right-2" alt="image"/>
        <img v-if="items.length > 2" :src="items[2]?.image ?? items[0]?.image"
             class="w-[143px] shadow z-10 absolute top-4 right-4" alt="image"/>
      </div>
    </div>
  </header>

  <main class="mx-auto p-[20px] mt-[18px] lg:max-w-[420px]">

    <h1 class="text-tc-subtitle font-bold text-tc-black font-minionpro tracking-wider leading-normal mb-[30px] max-w-[255px]"
    >Please verify your shipping address is correct.</h1>

    <div class="flex justify-between items-baseline">
      <p class="text-black font-normal font-avenir tracking-wider text-tc-xl"
         v-html="data?.shippingAddress?.replaceAll(', ', '<br>') + '<br>' + data.shippingPhone"
      ></p>
      <button @click="editAddress"
              class="text-tc-lg text-black font-avenir tracking-wider font-normal text-center bg-tc-off-white py-2 px-4">Edit
      </button>
    </div>

    <div class="my-[35px] flex flex-col lg:flex-row justify-between gap-5">
      <button type="submit"
          @click="clickToContinue"
          class="text-center font-avenir text-tc-xl tracking-wider border py-2.5 px-8 bg-tc-maroon text-white border-tc-maroon"
      >Continue
      </button>
      <button type="button"
          @click="clickToBack"
          class="text-center font-avenir text-tc-xl tracking-wider py-2.5 px-8 border border-tc-creme text-tc-creme"
      >Back
      </button>
    </div>

  </main>


</template>

<style scoped>
</style>